import { useSubscriptionsActions } from "store/SubscriptionsSlice";

const useSubscriptions = () => {
  const { createSubscription, getBillingInfo, updateBillingInfo } = useSubscriptionsActions();

  return { createSubscription, getBillingInfo, updateBillingInfo };
};

export default useSubscriptions;
